import Vue from "vue";
import Router from "vue-router";
import index from "@/pages/index/index";
import author from "@/pages/author/author";
import gcTrack from "@/utils/gcTrack";
import api from "@/utils/api";
import {
  setStorage,
  getStorage,
  removeStorage,
  getUrl,
  setUrl
} from "@/utils/wxuser";
import {
  isWeChat,
  scriptLoad,
  checkUrl,
  setCookie
} from "@/utils/utils";
import {
  baseUrl
} from "@/utils/baseUrl";
import { jAlert3 } from "../base/jAlert/jAlert";


Vue.use(Router);

let routes = [{
  path: "/",
  redirect: "index"
},

{
  path: "/author",
  name: "author",
  component: author,
  meta: {
    title: ""
  }
},
{
  path: "/index",
  name: "index",
  component: resolve => require(["@/pages/index/index"], resolve),
  meta: {
    title: ""
  }
},

{
  path: "/index2",
  name: "index2",
  component: resolve => require(["@/pages/index/index2"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/index3",
  name: "index3",
  component: resolve => require(["@/pages/index/index3"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/index4",
  name: "index4",
  component: resolve => require(["@/pages/index/index4"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/polymerization",
  name: "polymerization",
  component: resolve => require(["@/pages/mall/polymerization"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/goodsDetail",
  name: "goodsDetail",
  component: resolve => require(["@/pages/mall/goodsDetail"], resolve),
  meta: {
    title: "商品详情"
  }
},
{
  path: "/goodsListAll",
  name: "goodsListAll",
  component: resolve => require(["@/pages/mall/goodsListAll"], resolve),
  meta: {
    title: "商品列表"
  }
},
{
  path: "/shopCart",
  name: "shopCart",
  component: resolve => require(["@/pages/mall/shopCart"], resolve),
  meta: {
    title: "购物车"
  }
},
{
  path: "/settlement",
  name: "settlement",
  component: resolve => require(["@/pages/mall/settlement"], resolve),
  meta: {
    title: "确认订单"
  }
},
{
  path: "/orderList",
  name: "orderList",
  component: resolve => require(["@/pages/mall/orderList"], resolve),
  meta: {
    title: "我的订单"
  }
},
{
  path: "/orderDetail",
  name: "orderDetail",
  component: resolve => require(["@/pages/mall/orderDetail"], resolve),
  meta: {
    title: "我的订单"
  }
},
{
  path: "/giftCoupon",
  name: "giftCoupon",
  component: resolve => require(["@/pages/coupon/giftCoupon"], resolve),
  meta: {
    title: "领取优惠券"
  }
},
{
  path: "/giftList",
  name: "giftList",
  component: resolve => require(["@/pages/coupon/giftList"], resolve),
  meta: {
    title: "我的礼物券"
  }
},
{
  path: "/mySendCoupon",
  name: "mySendCoupon",
  component: resolve => require(["@/pages/coupon/mySendCoupon"], resolve),
  meta: {
    title: "我赠送的券"
  }
},
{
  path: "/couponDetail",
  name: "couponDetail",
  component: resolve => require(["@/pages/coupon/couponDetail"], resolve),
  meta: {
    title: "优惠券详情"
  }
},
{
  path: "/searchIndex",
  name: "searchIndex",
  component: resolve => require(["@/pages/mall/searchIndex"], resolve),
  meta: {
    title: "搜索"
  }
},
{
  path: "/typeList",
  name: "typeList",
  component: resolve => require(["@/pages/mall/typeList"], resolve),
  meta: {
    title: "分类"
  }
},
{
  path: "/addressManage",
  name: "addressManage",
  component: resolve => require(["@/pages/address/addressManage"], resolve),
  meta: {
    title: "地址"
  }
},
{
  path: "/addressEdit",
  name: "addressEdit",
  component: resolve => require(["@/pages/address/addressEdit"], resolve),
  meta: {
    title: "新增地址"
  }
},
{
  path: "/preNotifyList",
  name: "preNotifyList",
  component: resolve => require(["@/pages/mall/preNotifyList"], resolve),
  meta: {
    title: "预售专区"
  }
},
{
  path: "/shopFlashSale",
  name: "shopFlashSale",
  component: resolve => require(["@/pages/mall/shopFlashSale"], resolve),
  meta: {
    title: "秒杀"
  }
},
{
  path: "/shopFlashSaleAll",
  name: "shopFlashSaleAll",
  component: resolve => require(["@/pages/mall/shopFlashSaleAll"], resolve),
  meta: {
    title: "秒杀"
  }
},
{
  path: "/applyRefundReason",
  name: "applyRefundReason",
  component: resolve => require(["@/pages/mall/applyRefundReason"], resolve),
  meta: {
    title: "我的订单"
  }
},
{
  path: "/comment",
  name: "comment",
  component: resolve => require(["@/pages/mall/comment"], resolve),
  meta: {
    title: "评价"
  }
},
{
  path: "/groupBookDetail",
  name: "groupBookDetail",
  component: resolve => require(["@/pages/group/groupBookDetail"], resolve),
  meta: {
    title: "团购专区"
  }
},
{
  path: "/groupBookList",
  name: "groupBookList",
  component: resolve => require(["@/pages/group/groupBookList"], resolve),
  meta: {
    title: "团购专区"
  }
},
{
  path: "/booking",
  name: "booking",
  component: resolve => require(["@/pages/mall/booking"], resolve),
  meta: {
    title: "在线预约"
  }
},
{
  path: "/bookingExamine",
  name: "bookingExamine",
  component: resolve => require(["@/pages/mall/bookingExamine"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/bookingStatus",
  name: "bookingStatus",
  component: resolve => require(["@/pages/mall/bookingStatus"], resolve),
  meta: {
    title: "在线预约"
  }
},
{
  path: "/prePayList",
  name: "prePayList",
  component: resolve => require(["@/pages/mall/prePayList"], resolve),
  meta: {
    title: "预付专区"
  }
},
{
  path: "/rewardList",
  name: "rewardList",
  component: resolve => require(["@/pages/mall/rewardList"], resolve),
  meta: {
    title: "奖励明细"
  }
},
{
  path: "/giveCover",
  name: "giveCover",
  component: resolve => require(["@/pages/coupon/giveCover"], resolve),
  meta: {
    title: "选择卡券样式"
  }
},
{
  path: "/officialAccount",
  name: "officialAccount",
  component: resolve => require(["@/pages/mall/officialAccount"], resolve),
  meta: {
    title: "关注公众号"
  }
},
{
  path: "/shopCodeWritOff",
  name: "shopCodeWritOff",
  component: resolve => require(["@/pages/mall/shopCodeWritOff"], resolve),
  meta: {
    title: "核销"
  }
},
{
  path: "/shopCodeWritOffType",
  name: "shopCodeWritOffType",
  component: resolve => require(["@/pages/mall/shopCodeWritOffType"], resolve),
  meta: {
    title: "核销确认"
  }
},
{
  path: "/shopCodeForManual",
  name: "shopCodeForManual",
  component: resolve => require(["@/pages/mall/shopCodeForManual"], resolve),
  meta: {
    title: "核销确认"
  }
},
{
  path: "/collection",
  name: "collection",
  component: resolve => require(["@/pages/mall/collection"], resolve),
  meta: {
    title: "我的收藏"
  }
},
{
  path: "/memberCenter",
  name: "memberCenter",
  component: resolve => require(["@/pages/member/memberCenter"], resolve),
  meta: {
    title: "我的"
  }
},
{
  path: "/memberInfo",
  name: "memberInfo",
  component: resolve => require(["@/pages/member/memberInfo"], resolve),
  meta: {
    title: "我的"
  }
},
{
  path: "/posterTemplate",
  name: "posterTemplate",
  component: resolve => require(["@/pages/mall/posterTemplate"], resolve),
  meta: {
    title: "精品推荐"
  }
},
{
  path: "/couponCenterNew",
  name: "couponCenterNew",
  component: resolve => require(["@/pages/coupon/couponCenterNew"], resolve),
  meta: {
    title: "领券中心"
  },

},
{
  path: "/couponInfo",
  name: "couponInfo",
  component: resolve => require(["@/pages/coupon/couponInfo"], resolve),
  meta: {
    title: "领券中心"
  }
},
{
  path: "/couponList",
  name: "couponList",
  component: resolve => require(["@/pages/coupon/couponList"], resolve),
  meta: {
    title: "我的优惠券"
  }
},
{
  path: "/payOrderInfo",
  name: "payOrderInfo",
  component: resolve => require(["@/pages/common/payOrderInfo"], resolve),
  meta: {
    title: "订单详情"
  }
},
{
  path: "/dataClear",
  name: "dataClear",
  component: resolve => require(["@/pages/common/dataClear"], resolve),
  meta: {
    title: "数据清理"
  }
},
{
  path: "/supplierIndex",
  name: "supplierIndex",
  component: resolve => require(["@/pages/mall/supplierIndex"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/newUserArea",
  name: "newUserArea",
  component: resolve => require(["@/pages/activity/newUserArea"], resolve),
  meta: {
    title: "新人专区"
  }
},
{
  path: "/activeRule",
  name: "activeRule",
  component: resolve => require(["@/pages/activity/activeRule"], resolve),
  meta: {
    title: "规则说明"
  }
},
{
  path: "/employArea",
  name: "employArea",
  component: resolve => require(["@/pages/activity/employArea"], resolve),
  meta: {
    title: "特惠专区"
  }
},
{
  path: "/bookerManage",
  name: "bookerManage",
  component: resolve => require(["@/pages/mall/bookerManage"], resolve),
  meta: {
    title: "选择预订人"
  }
},
{
  path: "/bookerEdit",
  name: "bookerEdit",
  component: resolve => require(["@/pages/mall/bookerEdit"], resolve),
  meta: {
    title: "编辑预订人"
  }
},
{
  path: "/netError",
  name: "netError",
  component: resolve => require(["@/pages/other/netError"], resolve),
  meta: {
    title: "温馨提示"
  }
},
{
  path: "/delivery",
  name: "delivery",
  component: resolve => require(["@/pages/mall/delivery"], resolve),
  meta: {
    title: "物流信息"
  }
},
{
  path: "/chooseHotel",
  name: "chooseHotel",
  component: resolve => require(["@/pages/hotel/chooseHotel"], resolve),
  meta: {
    title: "适用门店"
  }
},
{
  path: "/pickUpPointList",
  name: "pickUpPointList",
  component: resolve => require(["@/pages/mall/pickUpPointList"], resolve),
  meta: {
    title: "自提点"
  }
},
{
  path: "/goodsPickUpPointList",
  name: "goodsPickUpPointList",
  component: resolve => require(["@/pages/mall/goodsPickUpPointList"], resolve),
  meta: {
    title: "自提点"
  }
},
{
  path: "/mysteryBoxList",
  name: "mysteryBoxList",
  component: resolve => require(["@/pages/activity/mysteryBoxList"], resolve),
  meta: {
    title: "盲盒"
  }
},
{
  path: "/getMainOpenid",
  name: "getMainOpenid",
  component: resolve => require(["@/pages/common/getMainOpenid"], resolve),
  meta: {
    title: "商城"
  }
},
{
  path: "/bookingForGoods",
  name: "bookingForGoods",
  component: resolve => require(["@/pages/mall/bookingForGoods"], resolve),
  meta: {
    title: "预约时间"
  }
},
{
  path: "/payBridge",
  name: "payBridge",
  component: resolve => require(["@/pages/common/payBridge"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/writOffCode",
  name: "writOffCode",
  component: resolve => require(["@/pages/mall/writOffCode"], resolve),
  meta: {
    title: "核销码"
  }
},
{
  path: "/collocationOrdersGoods",
  name: "collocationOrdersGoods",
  component: resolve => require(["@/pages/mall/collocationOrdersGoods"], resolve),
  meta: {
    title: "活动专区"
  }
},
{
  path: "/weatherDetail",
  name: "weatherDetail",
  component: resolve => require(["@/pages/mall/weatherDetail"], resolve),
  meta: {
    title: "天气"
  }
},
{
  path: "/plantingNotes",
  name: "plantingNotes",
  component: resolve => require(["@/pages/notes/plantingNotes"], resolve),
  meta: {
    title: "种草社区"
  }
},
{
  path: "/plantingNotesInfo",
  name: "plantingNotesInfo",
  component: resolve => require(["@/pages/notes/plantingNotesInfo"], resolve),
  meta: {
    title: "帖子详情"
  }
},
{
  path: "/videoNotesInfo",
  name: "videoNotesInfo",
  component: resolve => require(["@/pages/notes/videoNotesInfo"], resolve),
  meta: {
    title: "帖子详情"
  }
},
{
  path: "/fissionRank",
  name: "fissionRank",
  component: resolve => require(["@/pages/weCom/fissionRank"], resolve),
  meta: {
    title: "人气排行"
  }
},
{
  path: "/fissionPoster",
  name: "fissionPoster",
  component: resolve => require(["@/pages/weCom/fissionPoster"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/groupCode",
  name: "groupCode",
  component: resolve => require(["@/pages/weCom/groupCode"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/guidingWords",
  name: "guidingWords",
  component: resolve => require(["@/pages/weCom/guidingWords"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/weHotelQrCode",
  name: "weHotelQrCode",
  component: resolve => require(["@/pages/weCom/weHotelQrCode"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/likeActivity",
  name: "likeActivity",
  component: resolve => require(["@/pages/weCom/likeActivity"], resolve),
  meta: {
    title: "点赞活动"
  }
},
{
  path: "/allComment",
  name: "allComment",
  component: resolve => require(["@/pages/mall/allComment"], resolve),
  meta: {
    title: "全部评价"
  }
},

{
  path: "/sassGoodsDetail",
  name: "sassGoodsDetail",
  component: resolve => require(["@/pages/sass/sassGoodsDetail"], resolve),
  meta: {
    title: "商品详情"
  }
},

{
  path: "/openApplyForm",
  name: "openApplyForm",
  component: resolve => require(["@/pages/sass/openApplyForm"], resolve),
  meta: {
    title: "开通申请表"
  }
},
{
  path: "/salesAfterIfon",
  name: "salesAfterIfon",
  component: resolve => require(["@/pages/mall/salesAfterIfon"], resolve),
  meta: {
    title: "售后"
  }
},
{
  path: "/salesAfterDelivery",
  name: "salesAfterDelivery",
  component: resolve => require(["@/pages/mall/salesAfterDelivery"], resolve),
  meta: {
    title: "售后"
  }
},
{
  path: "/salesAfterHistory",
  name: "salesAfterHistory",
  component: resolve => require(["@/pages/mall/salesAfterHistory"], resolve),
  meta: {
    title: "协商历史"
  }
},
{
  path: "/rechargeCoupon",
  name: "rechargeCoupon",
  component: resolve => require(["@/pages/coupon/rechargeCoupon"], resolve),
  meta: {
    title: "我的充值卡"
  }
},
{
  path: "/goodsTypeList",
  name: "goodsTypeList",
  component: resolve => require(["@/pages/mall/goodsTypeList"], resolve),
  meta: {
    title: "商品列表"
  }
},
{
  path: "/shopRights",
  name: "goodsTypeList",
  component: resolve => require(["@/pages/coupon/shopRights"], resolve),
  meta: {
    title: "权益商城"
  }
},
{
  path: "/exchangeActivity",
  name: "exchangeActivity",
  component: resolve => require(["@/pages/activity/exchangeActivity"], resolve),
  meta: {
    title: "兑换专区"
  }
},
{
  path: "/exchangeGoodsList",
  name: "exchangeGoodsList",
  component: resolve => require(["@/pages/activity/exchangeGoodsList"], resolve),
  meta: {
    title: "兑换专区"
  }
},
{
  path: "/exchangeGoodsDetail",
  name: "exchangeGoodsDetail",
  component: resolve => require(["@/pages/activity/exchangeGoodsDetail"], resolve),
  meta: {
    title: "兑换专区"
  }
},
{
  path: "/exchange",
  name: "exchange",
  component: resolve => require(["@/pages/activity/exchange"], resolve),
  meta: {
    title: "兑换"
  }
},

{
  path: "/exchangeResult",
  name: "exchangeResult",
  component: resolve => require(["@/pages/activity/exchangeResult"], resolve),
  meta: {
    title: "兑换结果"
  }
},
{
  path: "/article",
  name: "article",
  component: resolve => require(["@/pages/other/article"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/articleList",
  name: "articleList",
  component: resolve => require(["@/pages/other/articleList"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/codeText",
  name: "codeText",
  component: resolve => require(["@/pages/other/codeText"], resolve),
  meta: {
    title: ""
  }
},
{
  path: "/productList",
  name: "productList",
  component: resolve => require(["@/pages/mall/productList"], resolve),
  meta: {
    title: "商品列表"
  }
},
{
  path: "/pay",
  name: "pay",
  component: resolve => require(["@/pages/mall/pay"], resolve),
  meta: {
    title: "付款"
  }
},
{
  path: "/paySta",
  name: "paySta",
  component: resolve => require(["@/pages/mall/paySta"], resolve),
  meta: {
    title: "支付完成"
  }
},
{
  path: "/hotelBooking",
  name: "hotelBooking",
  component: resolve => require(["@/pages/mall/hotelBooking"], resolve),
  meta: {
    title: "预约"
  }
},
{
  path: "/bookingDetails",
  name: "bookingDetails",
  component: resolve => require(["@/pages/mall/bookingDetails"], resolve),
  meta: {
    title: "预约详情"
  }
},
{
  path: "/bookingOrder",
  name: "bookingOrder",
  component: resolve => require(["@/pages/mall/bookingOrder"], resolve),
  meta: {
    title: "客房预订单"
  }
},
{
  path: "/myReward",
  name: "myReward",
  component: resolve => require(["@/pages/mall/myReward"], resolve),
  meta: {
    title: "我的奖励"
  }
},
{
  path: "/buyAgreement",
  name: "buyAgreement",
  component: resolve => require(["@/pages/mall/buyAgreement"], resolve),
  meta: {
    title: "购买协议"
  }
},
{
  path: "/exclusiveRight",
  name: "exclusiveRight",
  component: resolve => require(["@/pages/member/exclusiveRight"], resolve),
  meta: {
    title: "专属权益"
  }
},
{
  path: "/myExclusiveRight",
  name: "myExclusiveRight",
  component: resolve => require(["@/pages/member/myExclusiveRight"], resolve),
  meta: {
    title: "专属权益"
  }
},
{
  path: "/postNotes",
  name: "postNotes",
  component: resolve => require(["@/pages/notes/postNotes"], resolve),
  meta: {
    title: "发布笔记"
  }
},
{
  path: "/notesHome",
  name: "notesHome",
  component: resolve => require(["@/pages/notes/notesHome"], resolve),
  meta: {
    title: "我的主页"
  }
},
{
  path: "/certification",
  name: "certification",
  component: resolve => require(["@/pages/mall/certification"], resolve),
  meta: {
    title: "商家资质"
  }
},
{
  path: "/givePresent",
  name: "givePresent",
  component: resolve => require(["@/pages/mall/givePresent"], resolve),
  meta: {
    title: "一键送礼"
  }
},
{
  path: "/chooseInvoice",
  name: "chooseInvoice",
  component: resolve => require(["@/pages/invoice/chooseInvoice"], resolve),
  meta: {
    title: "申请开票"
  }
},
{
  path: "/invoiceList",
  name: "invoiceList",
  component: resolve => require(["@/pages/invoice/invoiceList"], resolve),
  meta: {
    title: "发票列表"
  }
},
{
  path: "/invoiceEdit",
  name: "invoiceEdit",
  component: resolve => require(["@/pages/invoice/invoiceEdit"], resolve),
  meta: {
    title: "发票编辑"
  }
},




];

const router = new Router({
  base: baseUrl,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if(to.query.savedPosition){
      return savedPosition
    }else{
      return {
        x: 0,
        y: 0
      };
    }

  }
});
async function memberLoginOpen(miniProgramOpenid) {
  let config = getStorage("config");
  return await api.memberLoginOpen({
    hotelCode: config.hotelCode,
    hotelGroupCode: config.hotelGroupCode,
    hotelGroupId: config.hotelGroupId,
    openid: miniProgramOpenid
  })
}
async function getMemberInfoByToken(opt) {
  let config = getStorage("config");
  return await api.getMemberInfoByToken({
    appid: config.appid,
    token:opt.token||"",
    distributorId:opt.distributorId||"",
    openid:opt.openid||"",
    isCreateTencentMember:opt.isCreateTencentMember||""
  })
}

async function memberLoginByMobileAndOpenId(info) {
  let config = getStorage("config");
  let wxuser = getStorage("wxuser");
  let cardSrc = getStorage("cardSrc");
  let obj = {
    hotelGroupCode: config.hotelGroupCode,
    openid: wxuser.openid,
    openIdType: "WEIXIN",
    hotelCode: config.hotelCode ? config.hotelCode : 0,
    hotelGroupId: config.hotelGroupId,
    mobile: info.mobileEnc ||"",
    nickName: info.name||"",
    componentAppid: config.componentAppid,
    appid: config.appid,
    sex:info.sex||"",
    idNo:info.idNo||"",
    cardSrc:cardSrc||""
  }
  let thirdPartyChannel = getStorage("thirdPartyChannel");
  if(thirdPartyChannel == 'yxy'){
    obj.openid = getStorage("yxyOpenId")||"";
  }
  return await api.memberLoginByMobileAndOpenId(obj)
}
async function toNext(to, from, next) {
  let thirdPartyChannel = getStorage("thirdPartyChannel");
  let token = getStorage("token");
  let user = getStorage("user");
  let wxuser = getStorage("wxuser");
  let distributorId = getStorage("distributorId");
  let isCreateTencentMember = getStorage("isCreateTencentMember");
  if(thirdPartyChannel == 'yxy'&&token&&wxuser&&wxuser.openid){
    try {
      let query = {
        token: token,
      }
      if(wxuser&&wxuser.openid){
        query.openid = wxuser.openid
      }
      if(distributorId){
        query.distributorId = distributorId
      }
      if(isCreateTencentMember){
        query.isCreateTencentMember = isCreateTencentMember
      }
      let res = await getMemberInfoByToken(query)
      setStorage("token", "");
      if(res.retVal.userinfo&&res.retVal.userinfo.yxyOpenId){
        let miniProgramOpenid = res.retVal.userinfo.yxyOpenId;
        setStorage("yxyOpenId", miniProgramOpenid);
        /* let wxuser = {
          openid: miniProgramOpenid,
          nickname: "微信用户",
          headimgurl: "https://xcx.ihotel.cn/hotel/images/avatar.jpg",
          openidFrom:"yxy"
        }
        setStorage("wxuser", wxuser); */
      }
      if(res.retVal.userinfo&&res.retVal.userinfo.mobile&&!(user&&user.memberId)){
        let newRes = await memberLoginByMobileAndOpenId(res.retVal.userinfo)
        if(newRes.result == 1){
          setStorage("cardSrc", "");
          setStorage("user", newRes.retVal);
          setStorage("isCreateTencentMember", "");
          setStorage("registrationMethod", "");
        }
      }

    } catch (error) {

    }
  }
  const queryData = to.query
  if (queryData.thirdAuthOpenid) {
    delete queryData.thirdAuthOpenid
    next({
      path: to.path,
      query: queryData,
      replace: true
    });
    return;
  }
  if (to.query.isOpenShare || to.query.distributorOpenId || to.query.belongHotelCode || to.query.toIndex || to.query.distributorMobile) {
    if (to.query.belongHotelCode) {
      try {
        const configNew = getStorage("config")
        configNew.hotelCode = to.query.belongHotelCode
        setStorage('belongHotelCode', to.query.belongHotelCode)
        setStorage('config', configNew)
      } catch (error) {

      }
    }else{
      let thirdPartyChannel = getStorage("thirdPartyChannel");
      if(thirdPartyChannel !== 'yxy'){
        removeStorage('belongHotelCode')
      }
    }
    next();
    return;
  }
  console.log(from.query.distributorMobile)
  if (from.query.distributorMobile) {
    queryData.distributorMobile = from.query.distributorMobile
  }
  if (from.query.distributorOpenId) {
    queryData.distributorOpenId = from.query.distributorOpenId
  }
  if (from.query.distributorId) (
    queryData.distributorId = from.query.distributorId
  )
  if (from.query.isOpenShare) {
    queryData.isOpenShare = from.query.isOpenShare
  }
  if (from.query.distributorOpenIdDis) {
    queryData.distributorOpenIdDis = from.query.distributorOpenIdDis
  }
  if (from.query.belongHotelCode && !to.query.isGroup) {
    queryData.belongHotelCode = from.query.belongHotelCode

  }
  if (from.name == 'polymerization') {
    if (!from.query.toIndex) {
      from.query.toIndex = from.query.id
    }
    delete queryData.backPage
  }
  if (from.query.toIndex) {
    queryData.toIndex = from.query.toIndex
  }

  if (from.query.distributorOpenId || from.query.distributorMobile || (from.query.belongHotelCode && !to.query.isGroup) || from.query.isOpenShare || from.query.toIndex) {
    if (from.path == to.path) {
      next({
        path: to.path,
        query: queryData,
        replace: true
      });
    } else {
      next({
        path: to.path,
        query: queryData

      });
    }

  } else {
    next();
  }
}
router.beforeEach(async (to, from, next) => {
  window.$gc.track();
  if (to.query.isCheckUrl) {
    sessionStorage.isCheckUrl = to.query.isCheckUrl;
  }
  let isCheckUrl = sessionStorage.isCheckUrl;
  if (isCheckUrl !== 'F') {
    checkUrl(to);
  }
  if (!getStorage('user')) {
    setStorage('user', "")
  }
  try {
    var visitLink = window.location.href + ';' + localStorage.getItem("visitLink")
    localStorage.setItem("visitLink", visitLink.substring(0, 1000))
    var user = getStorage("user");
    var wxuser = getStorage("wxuser");
    let is_login = false;
    let vip_level = "";
    let share_id = "";
    let share_id0 = "";
    if (user && user.memberId) {
      is_login = true;
      vip_level = user.cardLevel
    }
    if (to.query.toIndex) {
      window.$gc.setState("aggregateId", to.query.toIndex);
    }
    if (to.query.distributorId) {
      window.$gc.setState("distributorId", to.query.distributorId);
      window.$gc.setState("distributorBusinessType", 'shop');
    }

    if (to.query.distributorOpenIdDis || to.query.distributorOpenId) {
      share_id0 = to.query.distributorOpenIdDis || to.query.distributorOpenId
    }
    if (to.query.distributorId) {
      share_id = to.query.distributorId
    }
    let login_id = "";
    if (user && user.memberId && user.mobile) {
      login_id = user.mobile;
    } else if (wxuser && wxuser.openid) {
      login_id = wxuser.openid;
    }
    if (wxuser && wxuser.openid) {

      gcTrack.registerPage({
        is_login,
        vip_level,
        share_id,
        share_id0
      });
      // gcTrack.login(login_id)
    }

  } catch (error) {

  }
  const queryData = to.query
  /*title自定义*/
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "";
  }
  if (to.query.customTitle) {
    document.title = to.query.customTitle;
  }
  if (to.query.appid) {
    setStorage("appid", to.query.appid);
  }
  if (to.query.appId) {
    setStorage("appId", to.query.appId);
  }
  if (to.query.latitude) {
    setStorage("latitude", to.query.latitude);
  }
  if (to.query.longitude) {
    setStorage("longitude", to.query.longitude);
  }
  if (to.query.miniProgramOpenid) {
    setStorage("miniProgramOpenid", to.query.miniProgramOpenid);
  }
  var isMiniAppH5 = getStorage("isMiniAppH5");
  if (isMiniAppH5 == 'T') {
    let miniProgramOpenid = getStorage("miniProgramOpenid");
    if (miniProgramOpenid) {
      let wxuser = {
        openid: miniProgramOpenid,
        nickname: "微信用户",
        headimgurl: "https://xcx.ihotel.cn/hotel/images/avatar.jpg"
      }
      setStorage("wxuser", wxuser);

    }
  }
  if (to.query.scope) {
    sessionStorage.setItem('scope', to.query.scope);
  }
  if (to.query.staticFrom) {
    sessionStorage.setItem('staticFrom', to.query.staticFrom);
  }
  if (to.query.thirdPartyChannel) {
    setStorage("thirdPartyChannel", to.query.thirdPartyChannel);
  }
  if (to.query.thirdPartyChannel == 'tfbank' && !to.query.token) {
    setStorage("thirdPartyChannel", to.query.thirdPartyChannel);
    setStorage("tfToken", "");
    setStorage("user", "")
  }
  if (to.query.token) {
    if (to.query.thirdPartyChannel == 'tfbank') {
      setStorage("tfToken", to.query.token)
      setStorage("thirdPartyChannel", to.query.thirdPartyChannel)
    } else {
      setStorage("token", to.query.token)
    }
  }
  if (to.query.isCreateTencentMember) {
    setStorage("isCreateTencentMember", to.query.isCreateTencentMember)
  }
  if (to.query.distributorId) {
    let thirdPartyChannel = getStorage("thirdPartyChannel");
    if (thirdPartyChannel == 'yxy') {
      setStorage("distributorId", to.query.distributorId)
    }
  }
  if (to.query.registrationMethod) {
    setStorage("registrationMethod", to.query.registrationMethod)
  }
  if(to.path == "/payOrderInfo"){
    next()
    return;
  }
  if (to.query.cardSrc) {
    setStorage("cardSrc", to.query.cardSrc)
  }
  if (to.query.debugOpenId && to.path != "/author") {
    next({
      path: "author",
      query: {
        debugOpenId: to.query.debugOpenId,
        debugMode: 'T'
      }
    });
    return false;
  }

  if (isWeChat()) {
    let wxuser = getStorage("wxuser");
    if ((to.query.debugMode && to.query.debugMode == "T") || sessionStorage.getItem('debugMode') == "T") {
      if (!getStorage('wxuser')) {
        setStorage('wxuser', "")
      }
      if (!getStorage('user')) {
        setStorage('user', "")
      }
      sessionStorage.setItem('debugMode', 'T');
    } else {
      if (!wxuser && to.path != "/author") {
        setUrl(to.fullPath);
        next("/author");
        return false;
      }
    }

    if (to.query.thirdAuthOpenid) {
      setCookie('mainOpenid',to.query.thirdAuthOpenid)
      setStorage('mainOpenid', to.query.thirdAuthOpenid)
    }
    if (getStorage('thirdPartyChannel') != 'yxy'&&getStorage("gcPayTransMode4Shop") == '07' && getStorage("ShopShareRewardContent") == 'T' && !getStorage('mainOpenid') && to.path != "/author" && to.path != "/dataClear"&&to.path != "/payOrderInfo") {
      let config = getStorage("config");
      var querys = ""
      for (var i in to.query) {
        if (
          i != "customTitle"
        ) {
          if (querys == "") {
            querys = "?" + i + "=" + to.query[i];
          } else {
            querys += "&" + i + "=" + to.query[i];
          }
        }
      }
      if (Object.keys(to.query).length == 0) {
        querys = '?from=T'
      }
      var href = `${window.location.origin}${baseUrl}#${to.path}${querys}`
      let url = encodeURIComponent(href);
      var apiUrl = `https://wx19aca61bc2c91639.wx.gcihotel.net/api/wechat/platform/user/oauthV2?redirectUrl=${url}&wxAppid=wx19aca61bc2c91639&componentAppid=wxe715bd146a4e468b&openidName=thirdAuthOpenid&hotelGroupCode=GCGG&hotelCode=0&hotelGroupId=2&hotelId=0&channel=WECHAT`
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19aca61bc2c91639&redirect_uri=${encodeURIComponent(apiUrl)}&response_type=code&scope=snsapi_base&state=apiauthorize&component_appid=wxe715bd146a4e468b#wechat_redirect`
      return;
    }
    let miniProgramOpenid = getStorage("miniProgramOpenid");
    if (miniProgramOpenid) {
      var user = getStorage("user");
      if (!(user && user.memberId)) {
        let data = await memberLoginOpen(miniProgramOpenid);
        if (data.result == 1) {
          setStorage("user", data.retVal);
          toNext(to, from, next)
        } else {
          toNext(to, from, next);
        }
      } else {
        toNext(to, from, next)
      }
    } else {
      toNext(to, from, next)
    }


  } else {
    if ((to.query.debugMode && to.query.debugMode == "T") || sessionStorage.getItem('debugMode') == "T" || to.path == "/payBridge") {
      if (to.query.debugMode == "T") {
        sessionStorage.setItem('debugMode', to.query.debugMode);

        if (getStorage('wxuser') == undefined) {
          setStorage('wxuser', {})
          //setStorage('user',{})
        }

      }
      next();
    } else {
      var config = getStorage("config");
      let url = encodeURIComponent(window.location.href);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=apiauthorize&component_appid=${config.componentAppid}#wechat_redirect`
    }

    next();


  }
  try {
    _hmt && _hmt.push(["_trackPageview", to.fullPath]);
  } catch (e) { }
  // if(to.query.toIndex){

  // }
  if (to.path != '/goodsDetail') {
    setTimeout(() => {
      window.$gc.track();
    }, 500);
  }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js